import { ReactNode } from "react";

type Props = {
  children: ReactNode;
};

export const WeatherTableRowHead = ({ children }: Props) => {
  return <td className="text-center leading-[25px] bg-[#f8f8f8] border-r-[1px] border-r-[#adb5bd]">{children}</td>;
};
